import React from 'react';
import { createPortal } from 'react-dom';
import LocalizedText from '@LocalizedText';
import SvgIconUse from '@SvgIconUse';

import './UnsupportedOrientation.scss';

const UnsupportedOrientation = ({ visible }) => {
  const container = document.getElementById('qau-overlay-container');

  return visible ? (
    createPortal(
      <div className="qau-unsupported-orientation">
        <LocalizedText id="qau-unsupported-orientation" tagName="span" />
        <SvgIconUse id="unsupported-orientation" />
      </div>,
      container,
    )
  ) : (
    <></>
  );
};

export default UnsupportedOrientation;
